import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { GetPriceResponse } from '@leid/api-orders'

import { ItemApi } from 'appTypes/items'
import { CartFormValues } from 'appTypes/orders'

type UseIncludedFeesString = (
  product: ItemApi,
  values: CartFormValues,
  isProlonging: boolean,
  isRerent: boolean,
  productPrice: GetPriceResponse | null,
) => string | undefined

export const useIncludedFeesString: UseIncludedFeesString = (product, values, isProlonging, isRerent, productPrice) => {
  const { t } = useTranslation()

  return useMemo(() => {
    if (isRerent) {
      return undefined
    }

    const partsArray: Array<string> = []

    if (values.includeDeductibles && productPrice && productPrice.deductiblesPrice !== 0) {
      partsArray.push(t('common:reductionOfDeductible').toLocaleLowerCase())
    }

    if (values.includeInsurance && productPrice && productPrice.insurancePrice !== 0) {
      partsArray.push(t('common:insurance').toLocaleLowerCase())
    }

    if (partsArray.length === 0) {
      return undefined
    }

    let partsString = `${t('common:includingShort')} `

    partsArray.forEach((elem, i) => {
      if (i === 0) {
        // don't add any separator before first element
        partsString += elem
        return
      }

      if (i === partsArray.length - 1) {
        // if current element is the last one, add "and" string
        partsString += ` ${t('common:and')} ${elem}`
        return
      }

      partsString += `, ${elem}`
    })

    return partsString
  }, [
    isRerent,
    product.pricing?.handlingPrice,
    isProlonging,
    values.includeDeductibles,
    values.includeInsurance,
    productPrice,
    t,
  ])
}
